export const TEXTS = {
  EXPAND_TAGS: (count: number) => `Еще ${count}`,
  HIDE_TAGS: 'Скрыть',
  CLEAR_TAGS: 'Очистить',
  TAGS_FILTER_TITLE: 'Фильтр по тегам',
  TAGS_FILTER_SEARCH_TITLE: 'Поиск тегов',
};
